export default __webpack_public_path__ + "static/media/activity-active.dea777ef.svg";